import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mps_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // Public
  getBlogPosts: () => client.get("/blog").then((r) => r.data),
  getBlogPost: (slug) => client.get(`/blog/${slug}`).then((r) => r.data),
  submitOrder: (payload) => client.post("/orders", payload).then((r) => r.data),

  // Auth
  login: (email, password) =>
    client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),

  // Admin
  adminListPosts: () => client.get("/admin/blog").then((r) => r.data),
  adminCreatePost: (payload) =>
    client.post("/admin/blog", payload).then((r) => r.data),
  adminUpdatePost: (slug, payload) =>
    client.put(`/admin/blog/${slug}`, payload).then((r) => r.data),
  adminDeletePost: (slug) =>
    client.delete(`/admin/blog/${slug}`).then((r) => r.data),
  adminListOrders: () => client.get("/orders").then((r) => r.data),
  adminUpdateOrderStatus: (ref, status) =>
    client.patch(`/orders/${ref}/status`, { status }).then((r) => r.data),
  adminGetTodaysDigest: () =>
    client.get("/admin/digest/today").then((r) => r.data),
  adminMarkDigestSent: (dateStr) =>
    client.post(`/admin/digest/${dateStr}/sent`).then((r) => r.data),
  adminRegenerateDigest: () =>
    client.post("/admin/digest/regenerate").then((r) => r.data),
};
